import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

export interface CollapsibleSectionItem {
  label: string;
  value: React.ReactNode;
  isHeader?: boolean;
}

export type RulerMetricOption = 'valueDiff' | 'promedio' | 'min' | 'max';

export const RULER_METRIC_OPTIONS: { value: RulerMetricOption; label: string }[] = [
  { value: 'valueDiff', label: 'Valor 2 - Valor 1' },
  { value: 'promedio', label: 'Promedio' },
  { value: 'min', label: 'Mín entre líneas' },
  { value: 'max', label: 'Máx entre líneas' },
];

interface CollapsibleSectionProps {
  title: string;
  items: CollapsibleSectionItem[];
  defaultExpanded?: boolean;
  loading?: boolean;
  renderBeforeItems?: React.ReactNode;
}

function CollapsibleSection({
  title,
  items,
  defaultExpanded = false,
  loading = false,
  renderBeforeItems,
}: CollapsibleSectionProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      disableGutters
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={expanded
          ? <RemoveIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          : <AddIcon sx={{ fontSize: 20, color: 'text.secondary' }} />}
        sx={{
          minHeight: 40,
          '& .MuiAccordionSummary-content': {
            my: 0.5,
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, pb: 1 }}>
        <Box display="flex" flexDirection="column" gap={0.75}>
          {renderBeforeItems}
          {items.map((item, index) => (
            item.isHeader ? (
              <Typography
                key={`${item.label}-${index}`}
                variant="subtitle2"
                sx={{
                  fontWeight: 600, color: 'text.primary', mt: index > 0 ? 1 : 0,
                }}
              >
                {item.label}
              </Typography>
            ) : (
              <Box
                key={`${item.label}-${index}`}
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Typography
                  variant="subtitle2"
                  sx={{ color: 'text.secondary', flex: 1 }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: 'text.primary',
                    fontWeight: 600,
                    textAlign: 'right',
                    flex: 1,
                  }}
                >
                  {loading ? 'Cargando...' : item.value}
                </Typography>
              </Box>
            )
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default CollapsibleSection;
